import './radioCardGroup.scss';

import CssBaseline from '@mui/material/CssBaseline';
import { ReactNode } from 'react';

import { RadioCard } from '../RadioCard/RadioCard';
import { RadioCardGroupProps } from './types/RadioCardGroupProps';

export const RadioCardGroup = ({
  name,
  options,
  register,
  watch,
  defaultValue = '',
  testId,
  onClick,
}: RadioCardGroupProps): ReactNode => {
  const selectedValue = watch(name, defaultValue);

  return (
    <CssBaseline>
      <div className="radio-card-group" data-testid={testId} role="radiogroup">
        {options
          .filter((option): boolean => option.condition !== false)
          .map(
            (option): ReactNode => (
              <RadioCard
                {...register(name)}
                checked={selectedValue === option.value}
                data-testid={option.testId}
                image={option.image}
                key={option.value}
                subtitle={option.subtitle}
                title={option.title}
                value={option.value}
                onClick={onClick}
              />
            ),
          )}
      </div>
    </CssBaseline>
  );
};
